import React, { useState, useEffect } from 'react'
import { isArray, xor } from 'libraries/lodash'
import { toast } from 'react-toastify'
import cx from 'classnames'
import { NEVER, forkJoin, catchError } from 'rxjs'
import ClockIcon from '@material-ui/icons/AccessTime'
import ErrorIcon from '@material-ui/icons/Error'
import CheckIcon from '@material-ui/icons/CheckCircle'
import debug from 'front-end-core/core/debug'
import notificationToast from 'helpers/notificationToast'
import { updateUserPreferences, UserPreferences, User, updateUser } from 'services/SessionService'
import PageHeader from '../PageHeader'
import useObservable from 'front-end-core/hooks/useObservable'
import { isValidResponse } from 'front-end-core/helpers/dataflow'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import ControlButtons from './ControlButtons'
import SelectEmailOptIn from './SelectEmailOptIn'
import SelectEmailDays from './SelectEmailDays'
import { AOL_CORPORATE } from 'constants/aol/aol'

// TODO: move userPreferences state to redux "user"
const Preferences = ({ className }) => {
  const savedPreferences = useObservable(UserPreferences)
  const userDetails = useObservable(User)
  const [workingPreferences, setWorkingPreferences] = useState({})
  const [changed, setChanged] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  useEffect(() => {
    if (isValidResponse(savedPreferences)) {
      setWorkingPreferences({ ...savedPreferences })
    }
  }, [savedPreferences])

  useEffect(() => {
    setChanged(false)
    setSubmitted(false)
  }, [submitted])

  const handleChange = (name, value) => {
    const oldValue = workingPreferences[name]
    if (isArray(oldValue)) {
      value = xor(oldValue, [value])
    }
    setWorkingPreferences({ ...workingPreferences, [name]: value })
    setChanged(true)
  }

  const handleSave = () => {
    const { caEmails, caEmailDays } = workingPreferences
    const { caSource } = savedPreferences
    const notificationId = notificationToast(<ClockIcon />, toast.TYPE.INFO, 'Saving', '', false)

    setSubmitted(true)

    const payload = {
      firstName: userDetails.firstName,
      lastName: userDetails.lastName,
      marketingConsent: userDetails.marketingConsent,
      areaOfLaw: userDetails.areaOfLaw || AOL_CORPORATE
    }

    forkJoin([updateUserPreferences({ caEmails, caEmailDays, caSource }), updateUser(payload)])
      .pipe(
        catchError(e => {
          debug.warn(e)
          toast.dismiss(notificationId)
          notificationToast(<ErrorIcon />, toast.TYPE.ERROR, 'Please try again.', 'bg-indian-red white')
          return NEVER
        })
      )
      .subscribe(() => {
        toast.dismiss(notificationId)
        notificationToast(<CheckIcon />, toast.TYPE.SUCCESS, 'Preferences saved', 'bg-dark-sea-green white')
      })
  }

  const handleCancel = () => {
    setWorkingPreferences({ ...savedPreferences })
    setChanged(false)
    setSubmitted(false)
  }

  return (
    <ResponseConsumer
      response={savedPreferences}
      content={() => {
        const { caEmailDays = [], caEmails = false } = workingPreferences
        return (
          <form className={cx(className, 'flex flex-column f5 lighter')}>
            <div className='account-item-rows'>
              <PageHeader title='News email preferences' />
              <SelectEmailOptIn {...{ caEmails, handleChange }} />
              <SelectEmailDays {...{ caEmailDays, caEmails, handleChange }} />
            </div>
            <ControlButtons {...{ changed, handleSave, handleCancel }} />
          </form>
        )
      }}
    />
  )
}

export default Preferences
